import { render, staticRenderFns } from "./kundenschnellanlage.vue?vue&type=template&id=081db3b9&scoped=true"
import script from "./kundenschnellanlage.vue?vue&type=script&lang=js"
export * from "./kundenschnellanlage.vue?vue&type=script&lang=js"
import style0 from "./kundenschnellanlage.vue?vue&type=style&index=0&id=081db3b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081db3b9",
  null
  
)

/* custom blocks */
import block0 from "./kundenschnellanlage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports